import React from 'react'
import { PrismicLink } from '@prismicio/react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const CategoryCard = ({ item }) => {
  const itemData = item.node.data

  return (
    <li className='flex flex-col h-full flex-1'>
      <PrismicLink
        href={item.node.url}
        className='component-card ease relative flex flex-1 transform flex-col overflow-hidden bg-white group transition duration-300 ease-in-out focus:border-0 focus:shadow-none'>
        <div className='relative flex-shrink-0 overflow-hidden'>
          <GatsbyImage className='transition duration-300 ease-in-out group-hover:scale-105' image={getImage(itemData.page_image)} alt={itemData.page_image.alt || ''} />
        </div>
        <div className='p-6 flex flex-1 flex-col'>
          <div className='prose prose-lg mb-6'>
            <h3>{itemData.page_title.text}</h3>
            <div className='mb-0'>
              {itemData.page_text.text.split(' ').slice(0, 30).join(' ')}
              &hellip;
            </div>
          </div>
          <div className='mt-auto button button-default self-start'>Read more</div>
        </div>
      </PrismicLink>
    </li>
  )
}

export default CategoryCard
